import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { checkAuth } from './store/authSlice';
import './index.css';

const root = createRoot(document.getElementById('root'));

store.dispatch(checkAuth()).finally(() => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
});